import { render, staticRenderFns } from "./RequestSignUp.vue?vue&type=template&id=946b2dc0"
import script from "./RequestSignUp.vue?vue&type=script&lang=js"
export * from "./RequestSignUp.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports